import {isArray, isFunction} from 'lodash'
import router from '@/router'

/**
 * @param {{
 *     total: number,
 *     per_page: number,
 *     current_page: number,
 *     last_page: number,
 *     from: number,
 *     to: number,
 *     sort_by: string,
 *     sort_in: string
 * }} pagination
 * @returns {{
 *     per_page: number,
 *     sort_in: string,
 *     total_count: number,
 *     page: number,
 *     sort_by: string,,
 *     page_count: number
 * }}
 */
export function mapLegacyPagination (pagination) {
    const current = router.history?.current

    return {
        page: pagination.current_page,
        per_page: pagination.per_page,
        total_count: pagination.total,
        page_count: pagination.last_page,
        sort_by: current?.query?.sort_by,
        sort_in: current?.query?.sort_in
    }
}

/**
 * @param {string} value
 * @param {number} minimumFractionDigits
 * @param {string} prefix
 * @param {string} suffix
 * @returns {string}
 */
export function formatNumber (
    value,
    minimumFractionDigits = 2,
    prefix = '',
    suffix = ''
) {
    const parsedValue = parseNumber(value).toLocaleString(
        'en-GB',
        {minimumFractionDigits}
    )

    return `${prefix}${parsedValue}${suffix}`
}

/**
 * @param {string} value
 * @returns {number}
 */
export function parseNumber (value) {
    let parsedValue

    if (typeof value === 'string') {
        parsedValue = Number(value?.replace(/,/g, ''))
    } else {
        parsedValue = Number(value)
    }

    if (Number.isNaN(value)) {
        parsedValue = Number(0)
    }

    return parsedValue
}

/**
 * @param {string} value
 * @param {number} minimumFractionDigits
 * @param {string} prefix
 * @returns {string}
 */
export function formatMoney (value, minimumFractionDigits = 2, prefix = '£') {
    return formatNumber(value, minimumFractionDigits, prefix)
}

/**
 * @param {array|number} value
 * @returns {array|number}
 */
export function mapIntFilter (value) {
    return isArray(value)
        ? value.map(id => parseInt(id))
        : value
}

/**
 * @param {string} value
 * @returns {null|number}
 */
export function mapInt (value) {
    value = parseInt(value)
    return Number.isNaN(value) ? null : value
}

/**
 * @param {{[href]: function}} action
 * @param {{}} data
 * @returns {(*&{href})|*}
 */
export function mapAction (action, data) {
    if (isFunction(action.href)) {
        return {...action, href: action.href(data)}
    }

    return action
}

/**
 * @param {Function} apiMethod
 * @param {{number: string}} data
 * @param {string} mutationType
 * @param {boolean} pagination
 * @returns {Promise<*>}
 */
export async function handleApiCall({ commit, dispatch }, apiMethod, data, mutationType = null, pagination = false) {
    try {
        let response = await apiMethod(data);
        let info = response.data;
        if (!response.data) {
            info = response;
        }
        if(pagination) {
            info = {
                ...response,
                pagination: mapLegacyPagination(response.pagination)
            }
        }
        if (mutationType) {
            commit(mutationType, info);
        }
        return info;
    } catch (e) {
        const errorResponse = await dispatch('errors/addErrors', [e], { root: true });
        return Promise.reject(errorResponse[0]);
    }
}



export default {
    handleApiCall,
    formatNumber,
    formatMoney,
    mapLegacyPagination,
    mapIntFilter,
    mapInt,
    mapAction,
    parseNumber
}
